<template>
  <div class="parent-container">
    <nav class="navbar navbar-light bg-light">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img
            src="~dashboard/assets/images/menu-icons/header-logo.svg"
            alt="header-logo"
            height="60"
          />
        </a>
        <div class="navbar-right-content">
          <notification-bell />
          <agent-details @toggle-menu="toggleOptions" />
          <options-menu
            :show="showOptionsMenu"
            @toggle-accounts="toggleAccountModal"
            @show-support-chat-window="toggleSupportChatWindow"
            @key-shortcut-modal="toggleKeyShortcutModal"
            @close="toggleOptions"
          />
          <img
            role="button"
            src="~dashboard/assets/images/menu-icons/arrow-down.svg"
            class="dropdown-arrow"
            alt="dropdown-arrow"
            @click="toggleOptions"
          />
          <div
            class="toggle_item"
            @click="toggleMobileMenu(!mobileNav.isExpand)"
          >
            <fluent-icon
              v-if="mobileNav.isExpand"
              class="hamburger--menu"
              icon="dismiss"
            />
            <fluent-icon v-else class="hamburger--menu" icon="list" />
          </div>
        </div>
      </div>
    </nav>
    <TopNotificationBar :isSideOpen="isOnDesktop || isSidebarOpen" />
    <CallActionCard :isCollapsible="false" />
    <AudioCallWrapper />
    <div class="row app-wrapper dashboard_height">
      <sidebar
        ref="sidebar"
        :route="currentRoute"
        :class="sidebarClassName"
      ></sidebar>
      <section class="app-content columns" :class="contentClassName">
        <!-- register for incomming and outgoin call with absolute height -->
        <router-view></router-view>
        <command-bar />
      </section>
      <!-- Instruction modal Open to acess all pages  -->
      <DemoInstructionPopup />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Sidebar from '../../components/layout/Sidebar';
import TopNotificationBar from '../../components/layout/topbarComponents/TopNotificationBar.vue';
import CommandBar from './commands/commandbar.vue';
import { BUS_EVENTS } from 'shared/constants/busEvents';
import AgentDetails from '../../components/layout/sidebarComponents/AgentDetails.vue';
import OptionsMenu from '../../components/layout/sidebarComponents/OptionsMenu';
import NotificationBell from '../../components/layout/sidebarComponents/NotificationBell.vue';
import Cookies from 'js-cookie';
import DemoInstructionPopup from '../../components/layout/sidebarComponents/DemoInstructionPopup.vue';
import alertMixin from 'shared/mixins/alertMixin';
import CallActionCard from 'components/widgets/conversation/CallActionCard.vue';
import AudioCallWrapper from 'components/widgets/conversation/AudioCallWrapper.vue';

export default {
  components: {
    Sidebar,
    CommandBar,
    AgentDetails,
    OptionsMenu,
    NotificationBell,
    DemoInstructionPopup,
    TopNotificationBar,
    CallActionCard,
    AudioCallWrapper,
  },
  mixins: [alertMixin],
  data() {
    return {
      isSidebarOpen: false,
      isOnDesktop: true,
      showOptionsMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      mobileNav: 'getMobileNav',
    }),
    currentRoute() {
      return ' ';
    },
    sidebarClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas position-left is-transition-push is-open';
      }
      return 'off-canvas is-transition-push is-closed';
    },
    contentClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas-content is-open-left has-transition-push has-position-left';
      }
      return 'off-canvas-content has-transition-push';
    },
  },
  mounted() {
    this.$store.dispatch('setCurrentAccountId', this.$route.params.accountId);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    bus.$on(BUS_EVENTS.TOGGLE_SIDEMENU, this.toggleSidebar);

    try {
      const user = Cookies.getJSON('user') || {};

      // console.log('Updating DataLayer For ', user);

      let userData = user || null;

      if (userData) {
        window.dataLayer.push({
          user_email: userData.email || '',
          user_name: userData.name || '',
          ps_plan: userData.plan_id || 0,
          ps_account_id: userData.account_id || '',
          ps_stripe_user_id: userData.stripe_customer_id || '',
          ps_currency: userData.default_currency || '',
          ps_balance: userData.account_top_amount || 0,
          ps_total_topup: userData.total_top_amount || 0,
          onboard_limit: userData.onboard_limit || 0,
          role: userData.role || '',
        });
      }
    } catch (er) {
      console.error('Error updating DataLayer', er);
    }
  },
  beforeDestroy() {
    bus.$off(BUS_EVENTS.TOGGLE_SIDEMENU, this.toggleSidebar);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggleMobileMenu(isExpand) {
      this.$store.dispatch('toggleMobileNav', {
        ...this.mobileNav,
        isExpand,
      });
    },
    handleResize() {
      if (window.innerWidth > 1200) {
        this.isOnDesktop = true;
        this.toggleMobileMenu(false);
      } else {
        this.isOnDesktop = false;
      }
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleSupportChatWindow() {
      window.$peasy.toggle();
    },
    toggleAccountModal() {
      this.$refs.sidebar.toggleAccountModal();
    },
    toggleKeyShortcutModal() {
      this.$refs.sidebar.toggleKeyShortcutModal();
    },
  },
};
</script>
<style lang="scss" scoped>
// @import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/_variables.scss';
.dashboard_height {
  max-height: calc(100vh - 60px); // navbar height: 60px
  overflow: auto; // add hidden
}

.parent-container {
  // height: calc(100vh - 60px);
  height: 100%;
  min-height: 100vh;
}

.off-canvas-content.is-open-left {
  transform: translateX(25.4rem);
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: 60px;
  .container {
    width: 100%;
    padding-right: 3.171rem;
    margin-right: auto;
    margin-left: auto;

    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between;
    background-color: var(--white);
    border-bottom: 1px solid $border_mute;
  }
}

.navbar-brand {
  margin-right: 1rem;
  font-size: 1.25rem;
  text-decoration: none;
  white-space: nowrap;
  img {
    height: 60px;
  }
}

.navbar-right-content {
  display: flex;
}

.dropdown-arrow {
  padding-left: 12px;
  cursor: pointer;
}

.toggle_item {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 0;
  width: 40px;
}
</style>
